import { render, staticRenderFns } from "./CharacterMarketMiniPanel.vue?vue&type=template&id=628d4f82&"
import script from "./CharacterMarketMiniPanel.vue?vue&type=script&lang=js&"
export * from "./CharacterMarketMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports